
import router from '@/router'
import store from '@/store'

// 判断是否移动端
function isMobile() {
    const width = window.innerWidth
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) || width <= 600
}

const checkDevice = () => {
    // console.log(width, store.state.isMobile)
    const isNowMobile = isMobile()
    if (isNowMobile !== store.state.isMobile) {
        store.commit('setIsMobileValue', isNowMobile)
        switchRoute()
    }
}

const switchRoute = () => {
    const path = router.currentRoute.path
    // console.log(path)
    // 示例：/pc/home → /mobile/home
    if (store.state.isMobile && path.startsWith('/pc')) {
        const newPath = path.replace('/pc', '/mobile')
        // console.log(newPath);
        router.push(newPath)
    } else if (!store.state.isMobile && path.startsWith('/mobile')) {
        const newPath = path.replace('/mobile', '/pc')
        // console.log(newPath);
        router.push(newPath)
    }
}

function init() {
    // console.log(router)
    checkDevice()
    switchRoute()
    window.addEventListener('resize', checkDevice)
}

export default {
    init,
    checkDevice
}